<template>
  <!-- 跨级审批modal -->
  <a-modal
    title="提示"
    :visible="showModal"
    :confirm-loading="actionLoading"
    :mask-closable="false"
    @ok="handleCrossSubmit"
    @cancel="closeCrossModal"
    ok-text="继续提交"
    cancel-text="取消"
  >
    <p>注意：{{ crossHintMsg }}</p>
    <a-form
      :form="crossForm"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-item label="提交原因">
        <a-textarea
          v-decorator="$decorator('confirmRiskRemark', '请输入提交原因')"
          placeholder="请输入提交原因"
          :max-length="1000"
          allow-clear
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'CrossApproveModal',
  data() {
    return {
      crossForm: this.$form.createForm(this, {
        name: 'crossForm',
      }),
    }
  },
  mounted() {},
  props: ['showModal', 'actionLoading', 'crossHintMsg'],
  methods: {
    handleCrossSubmit() {
      this.crossForm.validateFields((err, values) => {
        if (!err) {
          const { confirmRiskRemark } = values
          this.$emit('onCrossSubmit', confirmRiskRemark)
          this.closeCrossModal()
        }
      })
    },
    closeCrossModal() {
      this.crossForm.resetFields()
      this.$emit('onCloseCrossModal')
    },
  },
}
</script>

<style></style>
